import Loading from "../../assets/icons/Loading";
import { refreshAccessToken } from "../../store/slice/authSlice";
import { AppDispatch, RootState } from "../../store/store";
import "./PurchaseForm.scss";
import { createPayment, validatePayment } from "./PurchaseForm.tools";
import KRGlue from "@lyracom/embedded-form-glue";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const PurchaseForm = ({
  amount,
  billingAddressId,
  deliveryAddressId,
  deliveryMode,
}: {
  amount: number;
  billingAddressId: string;
  deliveryAddressId: string;
  deliveryMode: string;
}) => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [orderId, setOrderId] = useState<string | null>(null);
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    if (!isAuthenticated) return;
    let resolver = () => {};

    const setupPaymentForm = async () => {
      const endpoint = process.env.REACT_APP_SYSTEMPAY_API_ENDPOINT || "";
      const publicKey = process.env.REACT_APP_SYSTEMPAY_PUBLIC_KEY || "";
      const { KR } = await KRGlue.loadLibrary(endpoint, publicKey);

      try {
        let formToken;

        const response = await createPayment(
          { amount, billingAddressId, deliveryAddressId, deliveryMode },
          () => dispatch(refreshAccessToken())
        );

        if (typeof response === "string") formToken = response;
        else {
          formToken = response.formToken;
          setOrderId(response.orderId);
        }

        await KR.setFormConfig({
          formToken,
          "kr-language": "fr-FR",
          "kr-clear-on-error": true,
        });

        await KR.onSubmit(async (paymentData) =>
          validatePayment(
            {
              ...paymentData,
              orderId,
            },
            setMessage,
            () => dispatch(refreshAccessToken()),
            () => navigate(`/invoice/${orderId}`)
          )
        );

        await KR.renderElements("#purchase-form");
        setLoading(false);
      } catch (error) {
        setMessage(
          error +
            (process.env.NODE_ENV === "production"
              ? " (see console for more details)"
              : "")
        );
      }
      resolver = () => KR.removeForms();
    };

    setupPaymentForm();
    return () => resolver();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="purchase-form-modale" onClick={(event) => event.stopPropagation()}>
      <h1>Régler l'achat</h1>
      {loading && <Loading className="loading" />}
      <div
        className="container"
        style={{ display: loading ? "none" : "block" }}
      >
        <div id="purchase-form">
          <div className="kr-smart-form"></div>
        </div>
        <div id="purchase-message" data-test="payment-message">
          <p>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default PurchaseForm;
